<template>
  <vs-popup class="customer-site-create-popup"
            id="popup"
            title="CREATE CUSTOMER SITE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSite)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="createForm.name"  name="name" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                <small class="label">Email</small>
                <vs-input  v-model="createForm.email" class="w-full"  name="email" type="text" label=""  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country_code_telephone" name="country_code_telephone" rules="required" v-slot="{ errors }">
                <small class="label">Country Code</small>
                <v-select :filter-by="myFilter" :clearable="false" name="country_code_telephone" placeholder=""
                          label="isd_code" v-model="createForm.country_code_telephone" :reduce="option => option.isd_code"
                          :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.isd_code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="telephone" name="telephone" rules="required" v-slot="{ errors }">
                <small class="label">Telephone</small>
                <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather" type="text" name="telephone" class="w-full" v-model="createForm.telephone"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country_code_fax" name="country_code_fax" rules="" v-slot="{ errors }">
                <small class="label">Country Code Fax</small>
                <v-select :filter-by="myFilter" :clearable="false" name="country_code_fax" placeholder=""
                          label="isd_code" v-model="createForm.country_code_fax" :reduce="option => option.isd_code"
                          :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.isd_code}} - {{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="fax" name="fax" rules="" v-slot="{ errors }">
                <small class="label">Fax</small>
                <vs-input :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                          val-icon-pack="feather" type="text" name="fax" class="w-full" v-model="createForm.fax"/>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="website" name="website" rules="" v-slot="{ errors }">
                <small class="label">Web Site</small>
                <vs-input v-model="createForm.website"   name="website" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                <small class="label">Address Line 1</small>
                <vs-input  v-model="createForm.address.line1" class="w-full"  name="line1" type="text" label=""  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                <small class="label">Address Line 2</small>
                <vs-input  v-model="createForm.address.line2" class="w-full"  name="line2" type="text" label=""  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                <small class="label">Address Line 3</small>
                <vs-input  v-model="createForm.address.line3" class="w-full"  name="line3" type="text" label=""  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                <small class="label">Name of Town / State</small>
                <vs-input  v-model="createForm.address.town_state" class="w-full"  name="town_state" type="text" label=""  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col  md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                <small class="label">Postal code</small>
                <vs-input  v-model="createForm.address.post_code" class="w-full"  name="post_code" type="text" label=""  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :filter-by="myFilter"  :clearable="false" name="country" placeholder="" label="name" v-model="createForm.address.country" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="customer_users" name="customer_users" rules="required" v-slot="{ errors }">
                <small class="label">Customer Users</small>
                <v-select multiple :clearable="false" name="customer_users" label="first_name"  v-model="createForm.customer_users" :reduce="option => option.id" :options="customerUsers" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.first_name}} {{option.last_name || ''}} </span>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <span>{{option.first_name}} {{option.last_name || ''}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Additional Information</small>
                <vs-textarea class="mb-0" v-model="createForm.additional_info" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      createForm: {
        address: {}
      },
      countryCodes: [],
      customerUsers: []
    }
  }

export default {
  name: 'TrackingImagePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())
        this.$vs.loading();
        await this.getCountryCodes()
        await this.fetchCustomerUsers()
        this.$vs.loading.close();
        this.open = true;
      } catch (error) {

      }
    },

    async onClickCreateSite () {
      const vue = this;
      this.$vs.loading()
       try {
         await SupplierRepository.createCustomerSite(this.createForm)
         this.showSuccessMessage('New customer site created successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async getCountryCodes() {
      this.$vs.loading()
      try {
        const {data} = (await SupplierManufactureRepository.getCountryCodes()).data
        this.countryCodes = data
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    async fetchCustomerUsers() {
      this.$vs.loading()
      const {data} = await SupplierRepository.get(1, this.filterQuery, 10, '')
      this.customerUsers =  data.data
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },

  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-site-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }

</style>
